export const stopPropagation = (e: Pick<Event, 'stopPropagation'>) => {
    e.stopPropagation();
};
